// Page title, description and sharing tags for signed-out pages, plus optional structured data.
// Canonical and share URLs always point at bumpups.com; non-production builds (QA) are noindex.
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { SOCIALS } from './siteLinks';

export const SITE_URL = 'https://bumpups.com';
const DEFAULT_IMAGE = `${SITE_URL}/socialpreviewbumpups.jpg`;
const INDEXABLE = process.env.REACT_APP_ENV === 'prod';

export const ORGANIZATION = {
  '@type': 'Organization',
  name: 'Bumpups',
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  email: 'contact@bumpups.com',
  sameAs: SOCIALS.map(s => s.href),
};

const absolute = url => (url.startsWith('http') ? url : SITE_URL + url);

export default function Seo({ title, description, image, type = 'website', jsonLd }) {
  const { pathname } = useLocation();
  const url = SITE_URL + (pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/'); // /pricing/ → /pricing
  const shareImage = image ? absolute(image) : DEFAULT_IMAGE;
  const data = [].concat(jsonLd || []);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {!INDEXABLE && <meta name="robots" content="noindex" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Bumpups" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={shareImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={shareImage} />
      {data.map(d => (
        <script key={d['@type']} type="application/ld+json">
          {JSON.stringify({ '@context': 'https://schema.org', ...d })}
        </script>
      ))}
    </Helmet>
  );
}
